import i18n from 'i18next';
import global_en from './en/global.json';
import global_fr from './fr/global.json';
i18n.init({
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    lng: 'en',
    debug: false,
    resources: {
        en: {
            global: global_en
        },
        fr: {
            global: global_fr
        }
    }
});
export default i18n;
